import "./App.css";
import Login from "./page/Login";
import { loginContext } from "./context/contexts";
import { useState } from "react";
import AdminPage from "./page/AdminPage";
import CustomerPage from "./page/CustomerPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UserDetail from "./components/UserDetail";
import UserPortal from "./page/UserPortal";
import PasswordChange from "./components/PasswordChange";
import DistributorPage from "./page/DistributorPage";
import DistributorUser from "./page/DistributorUser";

function App() {
  const [customer_id, setcustomer_id] = useState("");
  const [id, setid] = useState();
  const [hub, sethub] = useState();
  const [hubId, sethubId] = useState();

  const [page, setpage] = useState({
    addCustomer: false,
    addDevice: false,
    Organizations: false,
    Device: false,
    Settings: false,
    userDetail: false,
    deviceDetail: false,
    addUser: false,
    ManufacturedDevice: false,
    Hub: false,
    HubDevices: false,
    Admins: false,
    Distributors: true,
    replaceDevice: false,
    ChangeBillingType: false,
  });

  document.body.style.background = "#f3f3f4";

  return (
    <div
      style={{
        flexDirection: "column-reverse",
        justifyContent: "space-between",
      }}
    >
      <loginContext.Provider
        value={{
          customer_id: customer_id,
          setcustomer_id: setcustomer_id,

          id: id,
          setid: setid,
          page: page,
          setpage: setpage,
          hub: hub,
          sethub: sethub,
          hubId: hubId,
          sethubId: sethubId,
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/customer" element={<CustomerPage />} />
            <Route path="/" element={<Login />} />
            <Route path="/detail" element={<UserDetail />} />
            <Route path="/user" element={<UserPortal />} />
            <Route path="/password-change" element={<PasswordChange />} />
            <Route path="/distributor" element={<DistributorPage />} />
            <Route path="/distributor-user" element={<DistributorUser />} />
          </Routes>
        </BrowserRouter>
      </loginContext.Provider>
    </div>
  );
}

export default App;
